import React from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';

import { ChaptersQueryResult, useRequestNonprofitAccessMutation } from 'generated/graphql';
import { green, primaryBlue } from 'utils/color-styles';
import { renderAddress } from 'utils/renderAddress';
import { refetchUserAction } from 'entities/auth/actions';
import { UserState } from 'entities/user/reducer';

import DialogButton from '../../../retired/DialogButton/index';

type Nonprofit = NonNullable<
  NonNullable<NonNullable<ChaptersQueryResult['data']>['chapters']>[number]
>;

export const NonprofitRow = ({
  user,
  nonprofit,
  refetchNonprofits,
  loadingChapters,
}: {
  user: UserState;
  nonprofit: Nonprofit;
  refetchNonprofits: () => void;
  loadingChapters: boolean;
}) => {
  const dispatch = useDispatch();
  const [requestNonprofitAccess] = useRequestNonprofitAccessMutation({
    variables: { nonprofitId: nonprofit.nonprofitId || '' },
  });
  const [showSpinner, setShowSpinner] = React.useState(false);
  React.useEffect(() => {
    if (!loadingChapters) {
      setShowSpinner(false);
    }
  }, [loadingChapters]);

  return (
    <TableRow style={{ height: 60 }}>
      <TableCell>{nonprofit.name || ''}</TableCell>
      <TableCell>{renderAddress(nonprofit.locationObject)}</TableCell>
      <TableCell>{nonprofit.isParent ? 'Parent' : 'Chapter'}</TableCell>
      {user?.isAdmin && <TableCell>{nonprofit.invisible ? 'Yes' : 'No'}</TableCell>}
      <TableCell>
        {showSpinner ? (
          <CircularProgress size={22} />
        ) : (
          {
            none: (
              <DialogButton
                buttonProps={{
                  color: 'primary',
                  variant: 'outlined',
                  size: 'small',
                }}
                title={`Are you sure to request access to the ${
                  nonprofit.name || ''
                } organization?`}
                text=" If you confirm this action, we will notify the chapter nonprofit with this request. You will also be able to switch between organizations and will be able to verify yourself as the owner of this organization."
                confirmLabel="Confirm"
                cancelLabel="Cancel"
                handleConfirm={async () => {
                  setShowSpinner(true);
                  await requestNonprofitAccess();
                  refetchNonprofits();
                  dispatch(refetchUserAction());
                }}
              >
                <div>Request access</div>
              </DialogButton>
            ),
            requested: (
              <div style={{ fontWeight: 500, color: primaryBlue, opacity: 0.5 }}>
                Access Requested
              </div>
            ),
            granted: <div style={{ fontWeight: 500, color: green }}>Access Granted</div>,
          }[nonprofit.access || 'none']
        )}
      </TableCell>
    </TableRow>
  );
};
